import React, { useState, useEffect } from 'react';
import '../../common/scss/tag.selectbox.scss';

const TreehouseSelectbox = (params) => {
  const {
    treehousesList,
    selectedFilter,
    selectedTreehouse,
    setSelectedTreehouse,
    setIsDisabled,
    setSchoolQuery,
    setTreehouseQuery,
    setSchoolSubscribers,
    setTreehouseSubscribers,
    setIsAll,
    setUpcomingChallengeList,
    setPastChallengeList,
    setLiveChallengeList,
    setUpcomingQuery,
    setPastQuery,
    setCurrentQuery,
    isCommonRoom,
    tribeId
  } = params;
  const [showPane, setShowPane] = useState(false);
  const [rotate, setRotate] = useState('');
  const [tagOn, setTagOn] = useState(false);

  useEffect(() => {
    setTagOn(selectedTreehouse !== '');
    if (selectedTreehouse === '') return;
  }, [selectedTreehouse]);

  const rotateArrow = () => {
    setRotate(rotate === 'rotate-180' ? 'rotate-360' : 'rotate-180');
  };

  const handleSelectboxClick = (e) => {
    setShowPane(!showPane);
    rotateArrow();
  };

  const handleClick = (e) => {
    const tag = e.target.dataset.tag;
    if (selectedTreehouse?.id === Number(tag)) return;
    setSelectedTreehouse(treehousesList.filter(treehouse => {
      return treehouse.id === Number(tag)
    }));
    if (setIsAll) setIsAll("All");
    if (setTreehouseQuery) {
      setTreehouseQuery({
        limit: 10,
        has_more: true
      })
    }
    if (setSchoolQuery) {
      setSchoolQuery({
        limit: 10,
        has_more: true
      })
    }
    if (setSchoolSubscribers) {
      setSchoolSubscribers([])
    }
    if (setTreehouseSubscribers) {
      setTreehouseSubscribers([])
    }
    if (setIsDisabled) {
      setIsDisabled(false);
    }
    if (setUpcomingChallengeList) setUpcomingChallengeList([]);
    if (setPastChallengeList) setPastChallengeList([]);
    if (setLiveChallengeList) setLiveChallengeList([]);
    if (setUpcomingQuery) setUpcomingQuery({
      limit: 9,
      has_more: true,
      availability: "upcoming",
    })
    if (setPastQuery) setPastQuery({
      limit: 9,
      has_more: true,
      availability: "previous",
    })
    if (setCurrentQuery) setCurrentQuery({
      limit: 9,
      has_more: true,
      availability: "current",
    })
    setShowPane(false);
    rotateArrow();
  };
  const handleAllClick = () => {
    if (setIsAll) {
      setIsAll("All")
    }
    if (setTreehouseSubscribers) setTreehouseSubscribers([])
    if (setUpcomingChallengeList) setUpcomingChallengeList([]);
    if (setPastChallengeList) setPastChallengeList([]);
    if (setLiveChallengeList) setLiveChallengeList([]);
    if (setUpcomingQuery) setUpcomingQuery({
      limit: 9,
      has_more: true,
      availability: "upcoming",
    })
    if (setPastQuery) setPastQuery({
      limit: 9,
      has_more: true,
      availability: "previous",
    })
    if (setCurrentQuery) setCurrentQuery({
      limit: 9,
      has_more: true,
      availability: "current",
    })
    setShowPane(false);
    rotateArrow();
    if (setSelectedTreehouse) setSelectedTreehouse("All")
  }

  return (
    <div className="tagSelectbox-container kids-in-partner">
      <div
        className={`filter tag-selectbox ${tagOn ? 'tag-selected' : ''}`}
        onClick={handleSelectboxClick}
      >
        <div className="selected-tag">
          {!selectedTreehouse || selectedTreehouse === "All" ? "All Tribes" : isCommonRoom ? 'My Tribe' : selectedTreehouse[0]?.name}
        </div>
        <div className={`selectbox-arrow ${rotate}`}></div>
      </div>
      <div className={`tag-list-pane ${showPane ? 'show' : 'hide'}`}>
        <div
          className="tag-item"
          onClick={handleAllClick}
          data-tag="All"
        >
          All Tribes
        </div>
        {isCommonRoom ?
          treehousesList.filter((item) => item?.id === tribeId).map((treehouse, key) => {
            return (
              <div
                className="tag-item"
                onClick={handleClick}
                data-tag={treehouse.id}
                key={`item-${key}`}
              >
                {isCommonRoom ? 'My Tribe' : treehouse?.group?.name}
              </div>
            );
          })
          :
          treehousesList.map((treehouse, key) => {
            return (
              <div
                className="tag-item"
                onClick={handleClick}
                data-tag={treehouse.id}
                key={`item-${key}`}
              >
                {isCommonRoom ? 'My Tribe' : treehouse?.name}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default TreehouseSelectbox;
